var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBoldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8839 3.92447C11.2093 3.59903 11.7369 3.59903 12.0624 3.92447C12.3878 4.2499 12.3878 4.77754 12.0624 5.10298L9.17193 7.99342L12.0624 10.8839C12.3878 11.2093 12.3878 11.7369 12.0624 12.0624C11.7369 12.3878 11.2093 12.3878 10.8839 12.0624L7.99342 9.17193L5.10297 12.0624C4.77753 12.3878 4.24989 12.3878 3.92446 12.0624C3.59902 11.7369 3.59902 11.2093 3.92446 10.8839L6.81491 7.99342L3.92447 5.10298C3.59903 4.77754 3.59903 4.2499 3.92447 3.92447C4.2499 3.59903 4.77754 3.59903 5.10298 3.92447L7.99342 6.81491L10.8839 3.92447Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBoldIcon);
export default __webpack_public_path__ + "static/media/close-bold-icon.625e3cd2b97ebf0eba628ed2f58534ec.svg";
export { ForwardRef as ReactComponent };